export default "__VITE_ASSET__Bcu16Qij__"